import { render, staticRenderFns } from "./AcceptPoliciesCheckbox.vue?vue&type=template&id=15746efc"
import script from "./AcceptPoliciesCheckbox.vue?vue&type=script&lang=js"
export * from "./AcceptPoliciesCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15746efc')) {
      api.createRecord('15746efc', component.options)
    } else {
      api.reload('15746efc', component.options)
    }
    module.hot.accept("./AcceptPoliciesCheckbox.vue?vue&type=template&id=15746efc", function () {
      api.rerender('15746efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/forms/AcceptPoliciesCheckbox.vue"
export default component.exports